import { useState } from "react";
import { toast } from "react-toastify";
import { auth } from "../../../utils/firebaseConfig"; 
import Modal from "../presets/dialog";
import { sendPasswordResetEmail } from "firebase/auth";
import { useTranslation } from 'react-i18next';

export const PasswordResetDialog = () => {
  const { t } = useTranslation();  
  const [email, setEmail] = useState(null); 
  const [isOpen, setIsOpen] = useState(false);

  const passwordResetHandler = async () => {
    if (!email) {
      toast.error(t('EmptyEmailField'));
      return;
    }
    try {
      await sendPasswordResetEmail(auth, email);
      toast.success(t('ResetEmailSent')); 
      setIsOpen(false); 
    } catch (error) {
      toast.error(t('ErrorOccurred') + error.message); 
    }
  };

  return (
    <Modal
      status={isOpen}
      buttonLabel={t("ForgotPasswordButton")}  
      onClose={() => { setIsOpen(false); setEmail(null); }}
      buttonClassName={"button-reset"}
      body={
        <div>
          <div>
            <h6>{t('InstructionText')}</h6>  
          </div>
          <div className="my-4">
            <label className="form-label ml-1 mr-10 textLogin-label ml-1">
              {t('Email')}  
            </label>
            <input
              className="form-control input-login"
              placeholder={t('Insert')}  
              type="text"
              onChange={(e) => setEmail(e.target.value)} 
            />
          </div>
          <div className="flex justify-end mt-5">
            <button onClick={passwordResetHandler} className="background-black text-white mt-3 py-2 px-5 w-100 text-left border-none">
            {t('RetrieveAccountButton')} 
            </button>
          </div>
        </div>
      }
      title={t('ResetModalTitle')}  
      subtitle={t('ResetModalSubtitle')}  
    />
  );
};
